import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2782b97d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "arcode-workspace" }
const _hoisted_2 = { class: "workspace-bg text-center" }
const _hoisted_3 = { class: "text-center arcode-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center arcode-instructions" }, " Double Click to Start ", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ring lds-ring-small" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "tabs" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "tab-button-label" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "tabs-menu" }

import { 
  ref, onBeforeUpdate, watchEffect, onMounted
} from 'vue';
import { Workspace } from '@/core/Workspace';
import AnimatedLogo from '@/components/atomic/AnimatedLogo';
import DefaultIcon from '@/components/atomic/DefaultIcon';
import { appVersion } from '@/core/AppSettings';
import { createToast } from 'mosha-vue-toastify';
import tippy from 'tippy.js';
import { greeterContract } from '@/core/contract-sources/Greeter';


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultWorkspace',
  props: {
  theme: String,
  tx: String,
  networkParam: String,
  workspaceParam: String
},
  emits: [
  'openDialogLoadContractFromTx',
  'openDialogLoadWorkspaceFromTx'
],
  setup(__props, { expose, emit }) {

const props = __props;



const divs = ref([]);
const baseTheme = ref(props.theme);
const workspace = new Workspace(baseTheme.value, 'arcode-editor-tabs-container', props.tx, props.workspaceParam);
const editors = workspace.editors;
const loadingFromTX = ref(false);
const workspaceReady = ref(false);



const addEditor = (
  event: Event, 
  onlyInParent= false, 
  content='', 
  fileName='', 
  path='/',
  active=true,
  inFileTree=true,
  editorId=-1) => {
  try {
    workspace.addEditor(
      event, onlyInParent, content,
      path, fileName, baseTheme.value,
      active, inFileTree, editorId);
  } catch (err) {
    createToast(`editor: ${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
  }
  // emit('workspace-change', editors);
};
const selectEditor = (editorId: number, event: Event) => {
  workspace.selectEditor(editorId, event);
};
const deleteEditor = (editorId: number, event: Event) => {
  workspace.deleteEditor(editorId, event);
};

const deleteFolder = (path: string, event: Event) => {
  event.stopPropagation();
  event.preventDefault();
  workspace.deleteFolder(path);
};
const closeEditor = (editorId: number, event: Event) => {
  workspace.closeEditor(editorId, event);
};
const scrollEditor = (direction: string, translate = 120) => {
  workspace.scrollEditor(direction, translate);
};
const getEditorData = (editorId: number) => {
  return workspace.getEditorView(editorId);
};

const findFileIdByName = (path: string, filename: string) => {
  return workspace.fileTree.findFileIdByName(path, filename);
};

const setTheme = (editorId: number, theme: string) => {
  return workspace.setTheme(editorId, theme);
};
const setAppTheme = (theme: string) => {
  baseTheme.value = theme;
};

const getCurrentEditorId = () => {
  return workspace.currentEditorId;
};

const getFileTree = () => {
  return workspace.fileTree.tree;
};

const addFolder =  (path: string, folderName: string, debugInConsole=false) => {
  try {
    workspace.fileTree.addFolder(path, folderName);
  } catch (err) {
    if (debugInConsole) {
      console.error('addFolder', err);
    } else {
      createToast(`folder: ${err}`,
        {
          type: 'danger',
          showIcon: true,
          position: 'bottom-right',
        });
    }
  }
};

const isEditorActive = (editorId: number) => {
  return workspace.isEditorActive(editorId);
};

const getFileTreePaths = () => {
  const res = workspace.fileTree.getTreeAsPathStringArr();
  res.sort((a, b) => a.localeCompare(b))
  return res;
};

const getFileTreeFilenames = () => {
  return workspace.fileTree.getTreeAsFilenameStringArr();
};
const updateEditorName = (editorId: number, newName: string) => {
  try {
    return workspace.updateEditorNameFull(editorId, newName);
  } catch (err) {
    createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
  }
};

const loadExamples = () => {
  addFolder('/', 'Contracts');
  addFolder('/Contracts', 'greeter');
  const emptyEvent = new Event('emptyEvent');

  addEditor(
    emptyEvent,
    false,
    greeterContract.contract,
    greeterContract.name,
    '/contracts/greeter',
    false);
  addEditor(
    emptyEvent,
    false,
    greeterContract.state,
    greeterContract.stateName,
    '/contracts/greeter',
    false);
  
  window.setTimeout(() => {
    workspace.currentContent = '';
  }, 400)
};

const loadTree = () => {
  const filenames = getFileTreeFilenames();
  const emptyEvent = new Event('emptyEvent');

  for (const editorId in filenames) {
    //alert(filenames[editorId] + editorId)
    const explodePath = filenames[editorId].split('/');
    const fname = explodePath[explodePath.length - 1];
    const content = workspace.getCachedContent(editorId);
    explodePath.pop();

    addEditor(
      emptyEvent,
      false,
      content,
      fname,
      `${explodePath.join('/')}/`,
      false,
      false,
      editorId);
    
  }

  window.setTimeout(() => {
    workspace.currentContent = '';
  }, 400)
  
};

const getCurrentContent = () => {
  return workspace.currentContent;
};

// Expose public methods
expose({
  getEditorData,
  editors,
  deleteEditor,
  selectEditor,
  addEditor,
  setTheme,
  setAppTheme,
  getFileTree,
  addFolder,
  getCurrentEditorId,
  isEditorActive,
  getFileTreePaths,
  closeEditor,
  updateEditorName,
  getCurrentContent,
  deleteFolder,
  getFileTreeFilenames,
  findFileIdByName
});

// make sure to reset the refs before each update
onBeforeUpdate(() => {
  divs.value = []
});
watchEffect(() => {
  const divsCopy = divs.value;
  // Rebuild editors in workspace
  for (const id in divsCopy) {
    const div: HTMLElement = divsCopy[id] as HTMLElement;
    const divContent: string = div.innerHTML;
    if (divContent.trim() === '') {
      workspace.mountEditor(+id, div);
    }
  }
}, 
{
  flush: 'post'
});

onMounted(async () => {
  tippy('[data-tippy-workspace-content]', {
    arrow: true,
    placement: 'bottom',
    content: (reference) => reference.getAttribute('data-tippy-workspace-content')
  });

  // Load contract from url
  const tx = props.tx;
  const workspaceParam = props.workspaceParam;
  // IF Single File Mode
  if (tx) {
    createToast(`Running in Sandbox Mode.`,
      {
        type: 'warning',
        showIcon: true,
        position: 'bottom-right',
      });
    loadingFromTX.value = true;
    try {
      addFolder('/', tx);
      emit('openDialogLoadContractFromTx');
    } catch (err) {
      createToast(`${err}`,
        {
          type: 'danger',
          showIcon: true,
          position: 'bottom-right',
        });
    }
    loadingFromTX.value = false;
  }
  // Single File Mode: Workspace
  else if (workspaceParam) {
    createToast(`Running in Sandbox Mode.`,
      {
        type: 'warning',
        showIcon: true,
        position: 'bottom-right',
      });
    loadingFromTX.value = true;
    try {
      // Load workspace
      emit('openDialogLoadWorkspaceFromTx');
      // await loadWorkspaceFromParam(workspaceParam);
    } catch (err) {
      createToast(`${err}`,
        {
          type: 'danger',
          showIcon: true,
          position: 'bottom-right',
        });
    }
    loadingFromTX.value = false;
  }
  // Else, load stored tree
  else {
    const tree = getFileTree();
    if (tree.children.length === 0) {
      // Load examples
      loadExamples();
    } else {
     loadTree();
    }
  }
  // Workspace ready!
  workspaceReady.value = true;

});




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(AnimatedLogo)),
      _createElementVNode("h4", _hoisted_3, " ArCode Studio v" + _toDisplayString(_unref(appVersion)), 1),
      _hoisted_4,
      (loadingFromTX.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "workspace",
      onDblclick: _cache[4] || (_cache[4] = ($event: any) => (addEditor($event, true)))
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          id: "arcode-editor-tabs-container",
          class: "tabs-container",
          onDblclick: _cache[0] || (_cache[0] = ($event: any) => (addEditor($event, true)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editors), (editor) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: editor.id
            }, [
              (editor.active)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["tab", { active: editor.id == getCurrentEditorId() }]),
                    onClick: ($event: any) => (selectEditor(editor.id, $event))
                  }, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(editor.name), 1),
                    _createElementVNode("button", {
                      class: "button tab-button-close",
                      type: "button",
                      onClick: ($event: any) => (closeEditor(editor.id, $event))
                    }, "x", 8, _hoisted_11)
                  ], 10, _hoisted_9))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 32),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "button",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addEditor($event))),
            "data-tippy-workspace-content": "New File"
          }, [
            _createVNode(_unref(DefaultIcon), { icon: "codicon-new-file" })
          ]),
          _createElementVNode("button", {
            class: "button",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollEditor('left'))),
            "data-tippy-workspace-content": "Scroll left"
          }, [
            _createVNode(_unref(DefaultIcon), { icon: "codicon-chevron-left" })
          ]),
          _createElementVNode("button", {
            class: "button",
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollEditor('right'))),
            "data-tippy-workspace-content": "Scroll right"
          }, [
            _createVNode(_unref(DefaultIcon), { icon: "codicon-chevron-right" })
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editors), (editor) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: editor.id
        }, [
          (editor.active && getCurrentEditorId() >= 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["editor", { active: editor.id == getCurrentEditorId() }]),
                ref_for: true,
                ref: el => { if (el) { divs.value[editor.id] = el; } }
              }, null, 2))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ], 32)
  ]))
}
}

})